import React, { useEffect, useState } from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import useEffectAsync from '../../../../utilities/hooks/useEffectAsync';
import { connect } from 'react-redux';
import { goToPage, reportAnalytics } from '../PremiumPackagesCatalogSlice';
import Error from '../Partials/error/error';
import EpiContext from '@episerver/spa-core/Spa';
import Config from '../../../../Config';

const ErrorPage = (props) => {
    let formid = 'premiumPackagesCatalogForm';

    useEffect(() => {
    }, []);

    let currentPageView = (<Error type={props.errorPage.type} description={props.errorPage.description} onClickBtn={handleOnClickBtn} onServiceClick={handleOnServiceClick} onClickLink={handleOnClickLink} joinTvServiceLink={props.joinTvServiceLink} updatePaymentLink={props.updatePaymentLink} debtPaymentLink={props.debtPaymentLink} />);

    return (
        <div>
            <div className='premium-packages-catalog-content'>
                <form noValidate id={formid} onSubmit={handleSubmit}>
                    {currentPageView}
                </form>
            </div>
        </div>
    );


    function handleSubmit(event) {
        event.preventDefault();
    }

    function handleOnClickLink() {
        if (props.errorPage.type == "noTvSubscription") {
            props.reportAnalytics({
                eventCategory: 'premium_packages',
                eventAction: 'click_3',
                eventLabel: 'element_5',
            });
        }

    }

    function handleOnServiceClick(type) {
        if (props.errorPage.type == "noTvSubscription") {
            props.reportAnalytics({
                eventCategory: 'premium_packages',
                eventAction: 'click_2',
                eventLabel: 'element_4',
            });
        }
        if (type == 'Phone') {

        }
        else if (type == 'WhatsApp') {

        }
    }

    function handleOnClickBtn() {
        switch (props.errorPage.type) {
            case "noTvSubscription":
                EpiContext.navigateTo(Config.lobbyUrl)
                break;
            case "generalError":
                EpiContext.navigateTo(Config.lobbyUrl)
                break;
            default:
                break;
        }
    }
};

const mapStateToProps = (state) => {
    return {
        errorPage: state.premiumPackagesCatalog.errorPage,
        joinTvServiceLink: state.premiumPackagesCatalog.epiData.joinTvServiceLink,
        updatePaymentLink: state.premiumPackagesCatalog.epiData.updatePaymentLink,
        debtPaymentLink: state.premiumPackagesCatalog.epiData.debtPaymentLink,
    };
};

const mapDispatchToProps = {
    goToPage,
    reportAnalytics
};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorPage);
